import { useState, useEffect } from 'react';

const StepsCarousel = () => {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            number: 1,
            icon: "assets/images/service/07.svg",
            title: "Consultation & Planning",
            description: "We begin with a thorough consultation to understand your vision, budget, and project goals. Our team works with you to develop a tailored plan.",
            image: "../assets/images/service/step1.jpeg" // Replace with your image
        },
        {
            number: 2,
            icon: "assets/images/service/08.svg",
            title: "Design & Pre-Construction",
            description: "Our architects create detailed designs and blueprints. We handle all permits and approvals before construction begins.",
            image: "../assets/images/service/step2.jpeg" // Replace with your image
        },
        {
            number: 3,
            icon: "assets/images/service/09.svg",
            title: "Construction & Delivery",
            description: "Our skilled team executes the project with precision, maintaining quality standards and timelines until final delivery.",
            image: "../assets/images/service/step3.jpeg" // Replace with your image
        }
    ];

    const nextStep = () => {
        setCurrentStep((prev) => (prev === steps.length - 1 ? 0 : prev + 1));
    };

    const prevStep = () => {
        setCurrentStep((prev) => (prev === 0 ? steps.length - 1 : prev - 1));
    };

    const goToStep = (index) => {
        setCurrentStep(index);
    };

    // Auto-rotate the carousel every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            nextStep();
        }, 5000);

        return () => clearInterval(interval);
    }, [currentStep]);

    return (
        <div className="py-3 bg-white">
            <div className="container mx-auto px-4">

                <div className="flex flex-wrap items-center">
                    {/* Left side - Image Carousel */}
                    <div className="w-full lg:w-6/12 mb-8 lg:mb-0 lg:pr-12">
                        <div className="relative overflow-hidden rounded-lg shadow-xl">
                            <div className="relative h-80 md:h-96">
                                {steps.map((step, index) => (
                                    <div
                                        key={index}
                                        className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${index === currentStep ? 'opacity-100' : 'opacity-0'
                                            }`}
                                    >
                                        <img
                                            src={step.image}
                                            alt={`Step ${step.number}`}
                                            className="w-full h-full object-cover"
                                        />

                                        {/* Step indicator on image */}
                                        <div className="absolute bottom-4 left-4 bg-[#00A3A1] text-white px-4 py-2 rounded-lg font-semibold">
                                            Step {step.number}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Navigation arrows */}
                            <button
                                onClick={prevStep}
                                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md hover:bg-[#00A3A1] hover:text-white transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <button
                                onClick={nextStep}
                                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md hover:bg-[#00A3A1] hover:text-white transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </button>

                            {/* Navigation dots */}
                            <div className="absolute bottom-4 right-4 flex space-x-2">
                                {steps.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => goToStep(index)}
                                        className={`h-3 w-3 rounded-full ${index === currentStep ? 'bg-white' : 'bg-gray-300'
                                            }`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right side - Steps content */}
                    <div className="w-full lg:w-6/12">
                        <div className="mb-2">
                            <span className="text-[#00A3A1] font-medium mb-2 block">How We Work</span>
                            <h2 className="text-4xl text-[#063970] font-bold">
                                How To Work With Omanye
                            </h2>
                        </div>

                        <div className="space-y-2">
                            {steps.map((step, index) => (
                                <div
                                    key={step.number}
                                    className={`flex p-4 rounded-lg transition-all duration-300 cursor-pointer ${index === currentStep ? 'bg-gray-50 border-l-4 border-[#00A3A1]' : 'hover:bg-gray-50'
                                        }`}
                                    onClick={() => goToStep(index)}
                                >
                                    <div className="flex-shrink-0 mr-6 relative">
                                        <img src={step.icon} alt={step.title} className="h-12" />
                                        <span className="absolute -top-2 -right-2 bg-[#00A3A1] text-white rounded-full w-6 h-6 flex items-center justify-center text-xs">
                                            {step.number}
                                        </span>
                                    </div>
                                    <div>
                                        <h5 className="text-xl font-bold text-[#063970] mb-2">{step.title}</h5>
                                        <p className="text-[#000]">{step.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StepsCarousel;